import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Navbar } from "./components/Navbar/Navbar";
import Footer from "./components/Footer/Footer";
import HomePage from "./pages/HomePage";
import ProjectsPage from "./pages/ProjectsPage";
import BooksPage from "./pages/BooksPage";
import ContentPage from "./pages/ContentPage";
import "./App.css";

const App: React.FC = () => {
  return (
    <Router>
      <Navbar />
      <main className="main-content">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/projects" element={<ProjectsPage />} />
          <Route path="/books" element={<BooksPage />} />
          <Route path="/content" element={<ContentPage />} />
        </Routes>
      </main>
      <Footer />
    </Router>
  );
};

export default App;
